import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import transport from './modules/transport'
import messages from './modules/messages'
import notification from './modules/notification'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		auth,
		transport,
		messages,
		notification
	}
})
